<template>
  <div ref="container"></div>
</template>

<script>
import getEnv from "@/utils/env";
import { mapGetters } from "vuex";

export default {
  name: 'Chatbot',
   props: {            
    headerTitle: { type: String, default: 'QSC Chatbot' },
    errorMsg: {
      type: String,
      default: 'Server connection failed. If this persists, contact support at info@quasiris.com'
    },
    logoPath: {
      type: String,
      default: 'https://qsc-dev.quasiris.de/cdn/qsc/nassim/chat-bot/bot.png'
    }
  },
  data() { return { _chatbotModulePromise: null }; },

  computed: {
    ...mapGetters(['CHATBOT_CONFIG','SHOW_CHATBOT','CURRENT_TENANT']),
    restUrl() {
      const base = getEnv('VUE_APP_QSC_ADMIN_UI_CHAT_URL') || getEnv('VUE_APP_QSC_ADMIN_UI_URL');
      const path = this.CHATBOT_CONFIG
        ? `/api/v1/agent/chat/${this.CURRENT_TENANT.code}/${this.CHATBOT_CONFIG}`
        : `/api/v1/agent/chat/quasiris/qsc-admin-chat-agent`;
      return base ? `${base}${path}` : path;
    }
  },
   watch: {
    CHATBOT_CONFIG: {
      immediate: true,
      handler() {
        if (!this.SHOW_CHATBOT || !this.restUrl) {
          this._removeBot();
          return;
        }

        this._reloadBot();
      }
    },
    CURRENT_TENANT: {
      immediate: true,
      handler() {
        if (!this.SHOW_CHATBOT || !this.restUrl) {
          this._removeBot();
          return;
        }

        this._reloadBot();
      }
    },

    SHOW_CHATBOT(val) {
      if (!val) {
        this._removeBot();
      } else if (this.restUrl) {
        this._reloadBot();
      }
    }
  },

  mounted() {
    this._ensureModuleLoaded()
      .then(() => { if (this.restUrl && this.SHOW_CHATBOT) this._reloadBot(); })
      .catch(e => console.error('qsc-chatbot import failed', e));
  },

  beforeUnmount() { this._removeBot(); },

  methods: {
    _ensureModuleLoaded() {
      if (this._chatbotModulePromise) return this._chatbotModulePromise;
      if (typeof window === 'undefined') {
        this._chatbotModulePromise = Promise.resolve();
        return this._chatbotModulePromise;
      }
      if (window.customElements?.get('qsc-chatbot')) {
        this._chatbotModulePromise = Promise.resolve();
        return this._chatbotModulePromise;
      }

      this._chatbotModulePromise = import('@quasiris/qsc-chatbot-ui')
        .catch(() => import('@quasiris/qsc-chatbot-ui/dist/qsc-chatbot.js'));

      return this._chatbotModulePromise;
    },

    _reloadBot() { this._removeBot(); this._insertBot(); },

    _removeBot() {
      if (!this.$refs.container) return;
      const bot = this.$refs.container.querySelector('qsc-chatbot');
      if (bot) bot.remove();
    },

    _insertBot() {
      if (!this.$refs.container || !this.restUrl) return;
      const el = document.createElement('qsc-chatbot');
      el.setAttribute('rest-url', this.restUrl);
      el.setAttribute('header-title', this.headerTitle);
      el.setAttribute('error-msg', this.errorMsg);
      el.setAttribute('logo-path', this.logoPath);
      this.$refs.container.appendChild(el);
    }
  }
};
</script>
